export default {"src":"/_next/static/image/src/images/Footer/instagram.bcef16f7d3c83ac52849f714cf459534.svg","height":24,"width":24};